import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_inventory_lot_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { fullTextSearch?: string, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[], skip?: number, take?: number }): 
  Promise<{ result: { WarehouseId?: number, LotId?: number, PackagedId?: number, GrossWeight?: number, PackagedAmount?: number, Lot?: { LookupCode?: string, MaterialId?: number, ReceiveDate?: string, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Vat?: string }, Material?: { Description?: string, LookupCode?: string, ProjectId?: number, Project?: { LookupCode?: string } } }, Packaging?: { ShortName?: string }, Warehouse?: { Name?: string }, WeightUom?: { Short_name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_inventory_lot_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { fullTextSearch?: string, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[], skip?: number, take?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { WarehouseId?: number, LotId?: number, PackagedId?: number, GrossWeight?: number, PackagedAmount?: number, Lot?: { LookupCode?: string, MaterialId?: number, ReceiveDate?: string, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Vat?: string }, Material?: { Description?: string, LookupCode?: string, ProjectId?: number, Project?: { LookupCode?: string } } }, Packaging?: { ShortName?: string }, Warehouse?: { Name?: string }, WeightUom?: { Short_name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_inventory_lot_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { fullTextSearch?: string, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[], skip?: number, take?: number, $keys: { WarehouseId?: number, LotId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { WarehouseId?: number, LotId?: number, PackagedId?: number, GrossWeight?: number, PackagedAmount?: number, Lot?: { LookupCode?: string, MaterialId?: number, ReceiveDate?: string, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Vat?: string }, Material?: { Description?: string, LookupCode?: string, ProjectId?: number, Project?: { LookupCode?: string } } }, Packaging?: { ShortName?: string }, Warehouse?: { Name?: string }, WeightUom?: { Short_name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Inventory/datasources/ds_inventory_lot_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      fullTextSearch?: string, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[], skip?: number, take?: number    }) {
      return false;
    }
}
